export default __webpack_public_path__ + "static/student-enrollment-lms-integration-6ac7c8bfe0b3244aa8eb0994d5480e07.jpg";